import { Component, input, output } from '@angular/core';
import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { AssetService } from 'src/app/project/modules/fleet-management/asset-service/asset.service';

@Component({
    selector: 'pp-new-dashlet-modal-value-breakdown-fields-site-picker',
    templateUrl: './new-dashlet-modal-value-breakdown-fields-site-picker.component.html',
    styleUrl: './new-dashlet-modal-value-breakdown-fields-site-picker.component.scss',
    standalone: false
})
export class NewDashletModalValueBreakdownFieldsSitePickerComponent {
  ppSelectedAssetSite = input<string>();
  ppAssetId = input<string>();
  ppSelectSite = output<string>();

  assetSites: TSelectOption[] = [];
  assetSiteIndex = -1;

  constructor(private assetService: AssetService) {}

  ngOnChanges(): void {
    const asset = this.assetService.getAsset(this.ppAssetId());

    this.assetSites = asset.sites.map((site) => ({
      label: site.siteName,
      value: site.workspaceId,
    }));

    this.assetSiteIndex = this.assetSites.findIndex(
      (site) => site.value === this.ppSelectedAssetSite(),
    );
  }

  selectSite(site: TSelectOption): void {
    this.ppSelectSite.emit(site.value);
  }
}
